import { Component, Input, OnInit } from '@angular/core';
import { Lightbox } from 'ngx-lightbox';


@Component({
    selector: 'app-async-image',
    templateUrl: './async-image.component.html',
    styleUrls: ['./async-image.component.scss'],
    imports: []
})
export class AsyncImageComponent implements OnInit {

  @Input() public request: any;

  public isLoading = true;
  public imgBase64 = '';

  constructor(private lightbox: Lightbox) { }

  public ngOnInit(): void {
    this.isLoading = true;
    this.request.subscribe(base64 => {
      this.imgBase64 = base64;
      this.isLoading = false;
    });
  }

  public open(): void {
    this.lightbox.open([{src: this.imgBase64, thumb: null}], 0);
  }

}
